import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { Filter, Main } from 'Containers';
import { WAREHOUSE_KITCHEN_LOAD_FORM_NAME } from 'Common/FormEnum';
import { WarehouseReportEnum } from 'Common/FieldEnum';
import { makeOptionsData } from 'Common/FormHelper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

import * as actions from '../state/actions';
import WarehouseLoadComponent from './../components/WarehouseLoad';

class WarehouseLoadContainer extends Component {
  static propTypes = {
    initialValues: PropTypes.object.isRequired,
    printLoading: PropTypes.bool,
    data: PropTypes.array,
    storageLocationData: PropTypes.array,
    truckRouteData: PropTypes.array,
    onSubmit: PropTypes.func,
    onPrintClick: PropTypes.func,
    getMainProps: PropTypes.func,
    fetchWHKITListLoading: PropTypes.bool,
    fetchTruckRouteListLoading: PropTypes.bool,
    storageLocationDataLoading: PropTypes.bool,
  };
  static defaultProps = {
    printLoading: false,
    data: [],
    storageLocationData: [],
    truckRouteData: [],
    fetchWHKITListLoading: false,
    fetchTruckRouteListLoading: false,
    storageLocationDataLoading: false,
    onSubmit: () => {},
    onPrintClick: () => {},
    getMainProps: () => {},
  };
  currentDate = moment();
  state = {
    activeIndexes: [0, 1, 2],
    fromDateMax: null,
    toDateMin: null,
  };

  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const cloneActiveIndexes = _.clone(this.state.activeIndexes);
    cloneActiveIndexes.indexOf(index) !== -1
      ? cloneActiveIndexes.splice(cloneActiveIndexes.indexOf(index), 1)
      : cloneActiveIndexes.push(index);
    this.setState({ activeIndexes: cloneActiveIndexes });
  };
  onChangeOfFromDT = (e, beginDate) => {
    this.setState({
      toDateMin: moment(beginDate, DATE_FORMAT_FOR_UI),
    });
  };

  onChangeOfToDT = (e, endDate) => {
    this.setState({
      fromDateMax: moment(endDate, DATE_FORMAT_FOR_UI),
    });
  };
  clearFilter = () => {
    const { data, reset } = this.props;
    reset();
    data &&
      Array.isArray(data) &&
      data.length &&
      this.props.changeDropDownData(
        WarehouseReportEnum.WarehouseKitchen,
        data[0].Id
      );
    this.setState({
      activeIndexes: [0, 1, 2],
      fromDateMax: null,
      toDateMin: null,
    });
  };
  render() {
    const { activeIndexes } = this.state;
    const {
      storageLocationData,
      truckRouteData,
      getMainProps,
      data,
      fetchWHKITListLoading,
      fetchTruckRouteListLoading,
      storageLocationDataLoading,
    } = this.props;
    const { fromDateMax, toDateMin } = this.state;
    const storageLocationOptions = makeOptionsData(storageLocationData);
    const truckRouteOptions = makeOptionsData(truckRouteData);
    return (
      <Fragment>
        <Filter title={`Reports | Warehouse Pick List`} />
        <Main {...getMainProps()}>
          <WarehouseLoadComponent
            storageLocationOptions={storageLocationOptions}
            truckRouteOptions={truckRouteOptions}
            fromDateMax={fromDateMax}
            toDateMin={toDateMin}
            activeIndexes={activeIndexes}
            clearFilter={this.clearFilter}
            onChangeOfFromDT={this.onChangeOfFromDT}
            onChangeOfToDT={this.onChangeOfToDT}
            handleCollapsePanelClick={this.handleCollapsePanelClick}
            data={data}
            fetchWHKITListLoading={fetchWHKITListLoading}
            fetchTruckRouteListLoading={fetchTruckRouteListLoading}
            storageLocationDataLoading={storageLocationDataLoading}
          />
        </Main>
      </Fragment>
    );
  }
}
WarehouseLoadContainer = connect(
  null,
  {
    ...actions,
  }
)(WarehouseLoadContainer);

export const WarehouseLoad = reduxForm({
  form: WAREHOUSE_KITCHEN_LOAD_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(WarehouseLoadContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousepicklist/containers/WarehouseLoad.js